import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import BabillardListItemComponent from './BabillardListItemComponent.vue';
import httpClient from '@/Api/HttpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'BabillardListComponent',
  props: {
  translation: {
    type: String,
    required: true
  }
},
  setup(__props) {


const articles = ref<any[]>([]);
const errored = ref(false);
const loading = ref(true);
const currentDate = new Date(Date.now()).toISOString();

onMounted(() => {
  httpClient
    .get('/publications')
    .then(response => {
      articles.value = response.data.publications.filter((item: any) => item.statusId === 3 && item.dateFrom <= currentDate);
    })
    .catch(() => {
      errored.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
});


return (_ctx: any,_cache: any) => {
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_col = _resolveComponent("b-col")!

  return (errored.value)
    ? (_openBlock(), _createBlock(_component_b_container, {
        key: 0,
        class: "section",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(__props.translation), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_b_container, {
        key: 1,
        class: "section",
        fluid: ""
      }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_spinner, {
                    style: {"width":"3rem","height":"3rem","color":"#1702f8","margin":"auto"},
                    label: "Large Spinner",
                    type: "grow"
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_b_row, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_b_col, {
                      cols: "12",
                      key: index,
                      class: "U--p--0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BabillardListItemComponent, {
                          title: item.trans[0].title,
                          content: item.trans[0].description,
                          img: item.image,
                          url: item.website
                        }, null, 8, ["title", "content", "img", "url"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
        ]),
        _: 1
      }))
}
}

})